const FULL_REWARD_FIELDS = [
	'grossProfit',
	'correctionTotal',
	'totalCost',
	'totalRevenue',
	'trueProfit',
	'profitMarginRate',
	'correctionCoefficient',
	'assistantReward',
	'saleReward',
	'salesSupervisorReward',
	'companyProfit',
];

const normalizeId = (value) => {
	if (!value) return '';
	if (typeof value === 'object' && value._id) return String(value._id);
	return String(value);
};

const isSameUser = (left, right) => {
	const leftId = normalizeId(left);
	const rightId = normalizeId(right);
	return Boolean(leftId && rightId && leftId === rightId);
};

const pickRewardFields = (rewardSummary, fields) => {
	if (!rewardSummary || fields.length === 0) return null;
	return fields.reduce((acc, field) => {
		if (Object.prototype.hasOwnProperty.call(rewardSummary, field)) {
			acc[field] = rewardSummary[field];
		}
		return acc;
	}, {});
};

export const getVisibleOrderRewardFields = (viewer, order) => {
	if (!viewer) return [];

	if (['manager', 'admin', 'finance'].includes(viewer.role)) {
		return FULL_REWARD_FIELDS;
	}

	if (viewer.role === 'assistant') {
		return isSameUser(viewer, order?.assistantUser) ? ['assistantReward', 'saleReward', 'salesSupervisorReward'] : [];
	}

	if (viewer.isCoreSale || viewer.isSalesSupervisor) {
		return ['saleReward', 'salesSupervisorReward'];
	}

	if (viewer.role === 'sale' && isSameUser(viewer, order?.saleUser)) {
		return ['saleReward'];
	}

	return [];
};

export const filterRewardSummaryForViewer = (rewardSummary, viewer, order) => pickRewardFields(rewardSummary, getVisibleOrderRewardFields(viewer, order));
